"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEmitter = void 0;
const analytics_generic_utils_1 = require("@segment/analytics-generic-utils");
class NodeEmitter extends analytics_generic_utils_1.Emitter {
}
exports.NodeEmitter = NodeEmitter;
//# sourceMappingURL=emitter.js.map